// place.js: where the visitor probably is, from the time zone alone (no
// permission prompt, no network). Copied from web/src/astro.js whereAmI().
const CITIES = {
  'Asia/Kolkata': ['Mumbai', 19.076, 72.878], 'Asia/Calcutta': ['Mumbai', 19.076, 72.878],
  'Asia/Dubai': ['Dubai', 25.205, 55.271], 'Asia/Karachi': ['Karachi', 24.861, 67.01],
  'Asia/Dhaka': ['Dhaka', 23.811, 90.413], 'Asia/Kathmandu': ['Kathmandu', 27.717, 85.324],
  'Asia/Colombo': ['Colombo', 6.927, 79.861], 'Asia/Singapore': ['Singapore', 1.352, 103.82],
  'Asia/Hong_Kong': ['Hong Kong', 22.32, 114.17], 'Asia/Shanghai': ['Shanghai', 31.23, 121.47],
  'Asia/Tokyo': ['Tokyo', 35.676, 139.65], 'Asia/Jakarta': ['Jakarta', -6.208, 106.85],
  'Asia/Riyadh': ['Riyadh', 24.713, 46.675], 'Europe/Istanbul': ['Istanbul', 41.008, 28.978],
  'Europe/London': ['London', 51.507, -0.128], 'Europe/Paris': ['Paris', 48.857, 2.352],
  'Europe/Berlin': ['Berlin', 52.52, 13.405], 'Europe/Amsterdam': ['Amsterdam', 52.37, 4.895],
  'Europe/Madrid': ['Madrid', 40.417, -3.704], 'Europe/Rome': ['Rome', 41.903, 12.496],
  'Europe/Moscow': ['Moscow', 55.756, 37.617], 'Africa/Lagos': ['Lagos', 6.524, 3.379],
  'Africa/Johannesburg': ['Johannesburg', -26.204, 28.047], 'America/New_York': ['New York', 40.713, -74.006],
  'America/Toronto': ['Toronto', 43.653, -79.383], 'America/Chicago': ['Chicago', 41.878, -87.63],
  'America/Denver': ['Denver', 39.739, -104.99], 'America/Los_Angeles': ['Los Angeles', 34.052, -118.244],
  'America/Mexico_City': ['Mexico City', 19.433, -99.133], 'America/Sao_Paulo': ['São Paulo', -23.55, -46.633],
  'Australia/Sydney': ['Sydney', -33.869, 151.209], 'Australia/Melbourne': ['Melbourne', -37.814, 144.963],
};

export function whereAmI(Q) {
  let tz = 'Asia/Kolkata';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || tz; } catch (e) { /* keep default */ }
  let place;
  if (CITIES[tz]) {
    const [name, lat, lon] = CITIES[tz];
    place = { name, lat, lon, tz, guessed: false };
  } else {
    // Unknown zone: longitude from the UTC offset, a mid-northern latitude.
    const off = -new Date().getTimezoneOffset() / 60;
    const name = (tz.split('/').pop() || 'your city').replace(/_/g, ' ');
    place = { name, lat: 25, lon: off * 15, tz, guessed: true };
  }
  if (Q && Q.get('lat')) Object.assign(place, { lat: +Q.get('lat'), lon: +Q.get('lon'), name: Q.get('city') || 'here', guessed: false });
  return place;
}

export function fmtLatLon(lat, lon) {
  const a = `${Math.abs(lat).toFixed(2)}° ${lat >= 0 ? 'N' : 'S'}`;
  const b = `${Math.abs(lon).toFixed(2)}° ${lon >= 0 ? 'E' : 'W'}`;
  return `${a}  ${b}`;
}
